export const customerPasswordRegExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d|.*[!@#$%^&*()_+={}\[\]|\\:;"'<>,.?/~])(?=.{8,})/;
export const invalidPasswordMsg = 'Password must contain at least 8 characters, including uppercase, lowercase, number, and special character.';
